// extracted by mini-css-extract-plugin
export default {"heading":"Gu-z","corrected":"Hu-z","redirectVerbiageContainer":"Iu-z","redirectVerbiageText":"Ju-z"};